import { Container, InputField, TextAreaField } from "../../../utils/CustomComponents";

function Contact() {
    return (
        <>
            <div id="contact">
                <Container maxWidth={1000}>
                    <h1 className="header">Get in touch</h1>
                    <form>
                        <div className="grid">
                            <div className="grid_col">
                                <InputField placeholder="your name" header="your name" />
                                <InputField placeholder="email" header="email address" />
                                <InputField placeholder="phone" header="phone" />
                            </div>
                            <div className="grid_col">
                                <TextAreaField
                                    placeholder="Type your message here...."
                                    header="Message"
                                />
                            </div>
                        </div>
                        <button>send message</button>
                    </form>
                </Container>
            </div>
        </>
    );
}

export default Contact;
